export function hideElement(el, forceHide) {
  if (el.style.display !== 'none') { el.style.display = 'none'; }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/tiny-slider/src/helpers/hideElement.js
// module id = 321
// module chunks = 0